import { useState, useEffect } from "react";
import { MdCleaningServices } from "react-icons/md";
import { RiFullscreenLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const Navbar = () => {
  const navigate = useNavigate();

  // State to store real counts for admin
  const [diagnosticRequests, setDiagnosticRequests] = useState(0);
  const [doctorRequests, setDoctorRequests] = useState(0);

  // State for employee data
  const [role, setRole] = useState(null);
  const [userName, setUserName] = useState('');

  // State for the cache clear success popup
  const [cacheCleared, setCacheCleared] = useState(false);

  // Fetch counts from API on component mount for admin
  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const token = localStorage.getItem("authToken");
        
        const response = await axios.get("https://api.elthiumhealth.com/api/admin/getcount",
          {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
        );
        setDiagnosticRequests(response.data.totalDiagnosticBookings || 0);
        setDoctorRequests(response.data.totalDoctorAppointments || 0);
      } catch (error) {
        console.error("Error fetching counts:", error);
      }
    };

    const storedRole = localStorage.getItem("role");
    setRole(storedRole); // Set role based on localStorage

    // If role is employee, set the user data
    if (storedRole === "employee") {
      const storedEmployeeId = localStorage.getItem("employeeId");
      if (storedEmployeeId) {
        // Fetch employee info if needed (for example, their name)
        axios.get(`https://api.elthiumhealth.com/api/employee/${storedEmployeeId}`).then(response => {
          setUserName(response.data.name || 'Employee');
        });
      }
    } else if (storedRole === "admin") {
      // Admin fetches diagnostic and doctor requests count
      fetchCounts();
    }
  }, []);

  const handleClick = () => {
    navigate("/diagnosticslist");
  };

  const handleNavigation = () => {
    navigate("/appintmentlist");
  };

  const handleClearCache = () => {
    // Clear the cache (for example, clearing localStorage here)
    localStorage.clear();

    // Show success popup
    setCacheCleared(true);

    // Hide the popup after 3 seconds
    setTimeout(() => {
      setCacheCleared(false);
    }, 3000);
  };

  return (
    <nav className="bg-[#FFFFFF] text-black sticky top-0 w-full p-4 flex items-center shadow-lg z-50">
      <div className="flex justify-between items-center w-full">
        <div className="flex gap-3 ml-4">
          {/* Only show for Admin */}
          {role === "admin" && (
            <>
              <button
                className="relative font-semibold bg-[#F8FAF8] text-[#188753] p-3 rounded-md hover:bg-[#D9F3EA] duration-300"
                onClick={handleClick}
              >
                Health Care Bookings
                {diagnosticRequests > 0 && (
                  <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full">
                    {diagnosticRequests}
                  </span>
                )}
              </button>

              <button
                onClick={handleNavigation}
                className="relative font-semibold bg-[#F8FAF8] text-[#188753] p-3 rounded-md hover:bg-[#D9F3EA] duration-300"
              >
                Doctor Consultation Bookings
                {doctorRequests > 0 && (
                  <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full">
                    {doctorRequests}
                  </span>
                )}
              </button>
            </>
          )}

          {/* Show for Employee */}
          {role === "employee" && (
            <button
              onClick={handleClick}
              className="font-semibold bg-[#F8FAF8] text-[#188753] p-3 rounded-md hover:bg-[#D9F3EA] duration-300"
            >
              View Diagnostics
            </button>
          )}
        </div>

        <div className="flex gap-3 items-center">
          <div className="flex flex-col justify-center items-center">
            <img
              className="rounded-full w-[2vw]"
              src="/CompanyLogo.png"
              alt="Company Logo"
            />
            <h1 className="text-xs">{role === "admin" ? "Admin" : userName || "Employee"}</h1>
          </div>
        </div>
      </div>

      {/* Cache Clear Success Popup */}
      {cacheCleared && (
        <div className="absolute top-4 right-4 p-4 bg-green-500 text-white rounded-md shadow-lg">
          Cache cleared successfully!
        </div>
      )}
    </nav>
  );
};

export default Navbar;